"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'BasicMain',
  props: {
    radius: {
      type: [String, Number],
      default: 10
    },
    background: {
      type: String,
      default: ''
    },
    block: {
      type: Boolean,
      default: true
    },
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      span: 19
    };
  },
  computed: {
    styleName() {
      return {
        borderRadius: this.setPx(this.radius),
        background: this.background
      };
    },
    setConfig() {
      return {
        ...{
          leftCard: true,
          searchCard: true,
          containerCard: true
        },
        ...this.config
      };
    }
  },
  methods: {
    setSlot(slot) {
      return _.keys(this.$slots).includes(slot);
    }
  }
};